import { State as PaymentSelectMethodState } from '@client/reducers/payment-select-method-reducer';
import { Selector } from '@ngrx/store';
export const getIsActive: Selector<PaymentSelectMethodState, boolean> = (state: PaymentSelectMethodState) => state.isActive;
export const getSelectedMethod: Selector<PaymentSelectMethodState, string | null> = (state: PaymentSelectMethodState) =>
	state.selectedMethod;
export const getIsDasPaymentAccepted: Selector<PaymentSelectMethodState, boolean> = (state: PaymentSelectMethodState) =>
	state.isDasPaymentAccepted;
export const getIsBankingCardPaymentAccepted: Selector<PaymentSelectMethodState, boolean> = (state: PaymentSelectMethodState) =>
	state.isBankingCardPaymentAccepted;
export const getIsFinancialInstitutionPaymentAccepted: Selector<PaymentSelectMethodState, boolean> = (state: PaymentSelectMethodState) =>
	state.isFinancialInstitutionPaymentAccepted;
export const getIsPpaPaymentAccepted: Selector<PaymentSelectMethodState, boolean> = (state: PaymentSelectMethodState) =>
	state.isPpaPaymentAccepted;
